<template>
  <v-container
        class="fill-height"
        fluid>
        <v-row
          align="center"
          justify="center">
          <v-col
            cols="12"
            sm="8"
            md="4">
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat>
                <v-toolbar-title>Wachtwoord herstellen!</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form">
                  <v-text-field
                        v-model.trim="form.password"
                        :rules="passwordRules"
                        id="password"
                        label="Wachtwoord"
                        name="password"
                        prepend-icon="mdi-lock"
                        :disabled="isLoading"
                        type="password"
                    ></v-text-field>

                    <v-text-field
                        v-model.trim="form.confirmPassword"
                        :rules="confirmPasswordRules"
                        id="confirmPassword"
                        label="Bevestig Wachtwoord"
                        name="confirmPassword"
                        prepend-icon="mdi-lock"
                        :disabled="isLoading"
                        type="password"
                    ></v-text-field>
                </v-form>
                <v-alert
                    v-model="success"
                    :dismissible="true"
                    type="success"
                    class="mb-4">
                    <strong>Uw wachtwoord is gereset!</strong> Indien u problemen blijft houden, mail dan naar <a href="mailto:info@slaapp.nl">info@slaapp.nl</a> voor support.
                </v-alert>
                <v-alert
                    v-model="error"
                    :dismissible="true"
                    type="error"
                    class="mb-4">
                    <strong>Mislukt!</strong> Indien u problemen blijft houden, mail dan naar <a href="mailto:info@slaapp.nl">info@slaapp.nl</a> voor support.
                </v-alert>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="primary" 
                    @click="validate"
                    :disabled="isLoading || success">Resetten</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
</template>

<script>
const capitals = /^(?=.*[a-z])(?=.*[A-Z])/
const numbers = /^(?=.*[0-9])/
const special = /^(?=.*[?!@#\$%\^&\*])/
const length = /^(?=.{8,})/
const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  export default {
    data() {
      return {
        isLoading: false,
        success: false,
        error: false,
        form: {
            email: this.$route.query.username,
            password: null,
            confirmPassword: null,
            sex: 'm'
        },
        passwordRules: [
            v => !!v || 'Wachtwoord is verplicht.',
            v => capitals.test(v) || "Wachtwoord moet hoofd- en kleine letters bevatten.",
            v => numbers.test(v) || "Wachtwoord moet een nummer bevatten.",
            v => special.test(v) || "Wachtwoord minimaal een !, ?, @, #, % of * bevatten.",
            v => length.test(v) || "Wachtwoord moet minimaal 8 karakters zijn."
        ],
        confirmPasswordRules: [
          v => v === this.form.password || "Wachtwoorden komen niet overeen."
        ]
      }
    },

    methods: {
      validate () {
        if (this.$refs.form.validate()) {
            this.error = false;
            this.success = false;
            this.isLoading = true;
            this.$http.post("api/Auth/ResetPassword?token=" + encodeURIComponent(this.$route.query.token), this.form).then((res) => {
                this.success = true;
            }, () => {
                this.error = true;
            }).finally(() => {
                this.isLoading = false;
            })
        }
      }
    },
  }
</script>